// Animation functions
let _this = (module.exports = {
	// Set the dom elements
	dom: {
		items: [],
	},

	// Set variables
	vars: {
		// Class added when the element enters the viewport
		animatedClass: 'animated',
		// Class removed after the animation is done
		animationClass: 'animation',
		// Default time (ms) before the animation class is removed,
		// can be overridden per element with data-animation-duration="1500"
		duration: 1000,
		// Part of the element that has to be visible (0 - 1)
		threshold: 0.60,
	},

	/**
	 * Init functions
	 */
	init: function () {
		_this.dom.items = document.querySelectorAll('.' + _this.vars.animationClass);

		if (!_this.dom.items.length) {
			return;
		}

		// Fallback for old browsers - animate everything right away
		if (!('IntersectionObserver' in window)) {
			_this.dom.items.forEach(_this.animate);
			return;
		}

		const observer = new IntersectionObserver(_this.observerHandler, {
			threshold: _this.vars.threshold,
		});

		_this.dom.items.forEach((item) => observer.observe(item));
	},

	/**
	 * Intersection observer handler
	 * @param {IntersectionObserverEntry[]} entries
	 * @param {IntersectionObserver} observer
	 */
	observerHandler: function (entries, observer) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}

			// Animate only once
			observer.unobserve(entry.target);
			_this.animate(entry.target);
		});
	},

	/**
	 * Add the animated class and remove the animation class after the duration
	 * @param {HTMLElement} item
	 */
	animate: function (item) {
		const duration = parseInt(item.dataset.animationDuration ?? _this.vars.duration);

		item.classList.add(_this.vars.animatedClass);

		setTimeout(() => {
			item.classList.remove(_this.vars.animationClass);
		}, duration);
	},
});
